// import { useTranslation } from 'react-i18next'

// const { t } = useTranslation()

const datas = (t) => ({
  email: [
    {
      title: t('signup.data.email.title_1'),
      description: t('signup.data.email.description_1'),
    },
    {
      title: t('signup.data.email.title_2'),
      description: t('signup.data.email.description_2'),
    },
  ],
  confirmEmail: [
    {
      title: t('signup.data.confirmEmail.title_1'),
      description: t('signup.data.confirmEmail.description_1'),
    },
    {
      title: t('signup.data.confirmEmail.title_2'),
      description: t('signup.data.confirmEmail.description_2'),
    },
  ],
  invitations: [
    {
      title: t('signup.data.invitations.title_1'),
      description: t('signup.data.invitations.description_1'),
    },
    {
      title: t('signup.data.invitations.title_2'),
      description: t('signup.data.invitations.description_2'),
    },
  ],
  profileEdition: [
    {
      title: t('signup.data.profileEdition.title_1'),
      description: t('signup.data.profileEdition.description_1'),
    },
    {
      title: t('signup.data.profileEdition.title_2'),
      description: t('signup.data.profileEdition.description_2'),
    },
  ],
  information: [
    {
      title: t('signup.data.information.title_1'),
      description: t('signup.data.information.description_1'),
    },
    {
      title: t('signup.data.information.title_2'),
      description: t('signup.data.information.description_2'),
    },
  ],
  interests: [
    {
      title: t('signup.data.interests.title_1'),
      description: t('signup.data.interests.description_1'),
    },
    {
      title: t('signup.data.interests.title_2'),
      description: t('signup.data.interests.description_2'),
    },
  ],
  success: [
    {
      title: t('signup.data.success.title_1'),
      description: t('signup.data.success.description_1'),
    },
    {
      title: t('signup.data.success.title_2'),
      description: t('signup.data.success.description_2'),
    },
  ],
})

export default datas
